<template>
  <!-- Persistent cause https://github.com/vuetifyjs/vuetify/issues/5200 -->
  <v-dialog persistent v-model="showDialog" max-width="900" transition="dialog-bottom-transition">
    <v-card>
      <v-card-title primary-title class="headline orange">
        <v-layout column>
          <span class="title font-weight-light white--text">Add Tariff Modifier</span>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <v-form ref="modifierForm" v-model="valid">
          <v-layout style="width: 100%" row wrap>
            <v-flex xs12 md12>
              <h4 class="grey--text text--darken-1">Modifier</h4>
            </v-flex>
            <v-flex xs6 md4 px-2>
              <v-text-field
                :error-messages="errorForField('name')"
                :rules="modifierRules.name"
                v-model="modifierStore.name"
                label="Name"
                @input="resetError('name')"
              />
            </v-flex>
          </v-layout>
          <v-layout style="width: 100%" row wrap pb-2>
            <v-flex xs12 md12 pb-1>
              <h4 class="grey--text text--darken-1">Triggers - Days of Week</h4>
            </v-flex>
            <v-flex xs3 md3 pl-3 pr-2 pt-2>
              <v-checkbox v-model="modifierStore.monday" color="primary" label="Monday" />
            </v-flex>
            <v-flex xs3 md3 pl-3 pr-2 pt-2>
              <v-checkbox v-model="modifierStore.tuesday" color="primary" label="Tuesday" />
            </v-flex>
            <v-flex xs3 md3 pl-3 pr-2 pt-2>
              <v-checkbox v-model="modifierStore.wednesday" color="primary" label="Wednesday" />
            </v-flex>
            <v-flex xs3 md3 pl-3 pr-2 pt-2>
              <v-checkbox v-model="modifierStore.thursday" color="primary" label="Thursday" />
            </v-flex>
            <v-flex xs3 md3 pl-3 pr-2 pt-2>
              <v-checkbox v-model="modifierStore.friday" color="primary" label="Friday" />
            </v-flex>
            <v-flex xs3 md3 pl-3 pr-2 pt-2>
              <v-checkbox v-model="modifierStore.saturday" color="primary" label="Saturday" />
            </v-flex>
            <v-flex xs3 md3 pl-3 pr-2 pt-2>
              <v-checkbox v-model="modifierStore.sunday" color="primary" label="Sunday" />
            </v-flex>
            <v-flex xs3 md3 pl-3 pr-2 pt-2>
              <v-checkbox
                v-model="modifierStore.bank_holiday"
                color="primary"
                label="Bank Holiday"
              />
            </v-flex>
          </v-layout>
          <v-layout style="width: 100%" row wrap pb-2>
            <v-flex xs12 md12 pb-1>
              <h4 class="grey--text text--darken-1">Triggers - Hour Period</h4>
            </v-flex>
            <v-flex xs4 md4 px-2>
              <!--
              <TimeInput
                :error-messages="errorForField('hour_period_start')"
                :rules="modifierRules.hour_period_start"
                v-model="modifierStore.hour_period_start"
                label="Start Time"
                @input="resetError('hour_period_start')"
                :clearable="false"
              />
              -->
              <v-text-field
                :error-messages="errorForField('hour_period_start')"
                :rules="modifierRules.hour_period_start"
                v-model="modifierStore.hour_period_start"
                label="Start Time"
                prepend-inner-icon="access_time"
                @input="resetError('hour_period_start')"
              />
            </v-flex>
            <v-flex xs4 md4 px-2>
              <!--
              <TimeInput
                :error-messages="errorForField('hour_period_end')"
                :rules="modifierRules.hour_period_end"
                v-model="modifierStore.hour_period_end"
                label="End Time"
                @input="resetError('hour_period_end')"
                :clearable="false"
              />
              -->
              <v-text-field
                :error-messages="errorForField('hour_period_end')"
                :rules="modifierRules.hour_period_end"
                v-model="modifierStore.hour_period_end"
                label="End Time"
                prepend-inner-icon="access_time"
                @input="resetError('hour_period_end')"
              />
            </v-flex>
          </v-layout>
          <v-layout style="width: 100%" row wrap pb-2>
            <v-flex xs12 md12 pb-1>
              <h4 class="grey--text text--darken-1">Triggers - Day Period</h4>
            </v-flex>
            <v-flex xs4 md4 px-2>
              <v-select
                :items="months"
                item-text="name"
                item-value="value"
                :error-messages="errorForField('day_period_start_month')"
                :rules="modifierRules.day_period_start_month"
                v-model="modifierStore.day_period_start_month"
                label="Start Month"
                prepend-inner-icon="calendar_today"
                @input="resetError('day_period_start_month')"
              />
            </v-flex>
            <v-flex xs4 md4 px-2>
              <v-select
                :items="dates"
                :error-messages="errorForField('day_period_start_date')"
                :rules="modifierRules.day_period_start_date"
                v-model="modifierStore.day_period_start_date"
                label="Start Day"
                prepend-inner-icon="today"
                @input="resetError('day_period_start_date')"
              />
            </v-flex>
            <v-flex xs4 md4 px-2>
              <!--
              <TimeInput
                :error-messages="errorForField('day_period_start_time')"
                :rules="modifierRules.day_period_start_time"
                v-model="modifierStore.day_period_start_time"
                label="Start Time"
                @input="resetError('day_period_start_time')"
                :clearable="false"
              />
              -->
              <v-text-field
                :error-messages="errorForField('day_period_start_time')"
                :rules="modifierRules.day_period_start_time"
                v-model="modifierStore.day_period_start_time"
                label="Start Time"
                prepend-inner-icon="access_time"
                @input="resetError('day_period_start_time')"
              />
            </v-flex>
            <v-flex xs4 md4 px-2>
              <v-select
                :items="months"
                item-text="name"
                item-value="value"
                :error-messages="errorForField('day_period_end_month')"
                :rules="modifierRules.day_period_end_month"
                v-model="modifierStore.day_period_end_month"
                label="End Month"
                prepend-inner-icon="calendar_today"
                @input="resetError('day_period_end_month')"
              />
            </v-flex>
            <v-flex xs4 md4 px-2>
              <v-select
                :items="dates"
                :error-messages="errorForField('day_period_end_date')"
                :rules="modifierRules.day_period_end_date"
                v-model="modifierStore.day_period_end_date"
                label="End Day"
                prepend-inner-icon="today"
                @input="resetError('day_period_end_date')"
              />
            </v-flex>
            <v-flex xs4 md4 px-2>
              <v-text-field
                :error-messages="errorForField('day_period_end_time')"
                :rules="modifierRules.day_period_end_time"
                v-model="modifierStore.day_period_end_time"
                label="End Time"
                prepend-inner-icon="access_time"
                @input="resetError('day_period_end_time')"
              />
            </v-flex>
          </v-layout>
          <v-layout style="width: 100%" row wrap pb-2>
            <v-flex xs12 md12 pb-1>
              <h4 class="grey--text text--darken-1">Tariff</h4>
            </v-flex>
            <v-flex xs3 md3 px-2>
              <v-text-field
                :error-messages="errorForField('base_fare')"
                :rules="modifierRules.base_fare"
                v-model="modifierStore.base_fare"
                prefix="£"
                type="number"
                class="noStepNumber"
                label="Base Fare"
                @input="resetError('base_fare')"
              />
            </v-flex>
            <v-flex xs3 md3 px-2>
              <v-text-field
                :error-messages="errorForField('per_mile_fare')"
                :rules="modifierRules.per_mile_fare"
                v-model="modifierStore.per_mile_fare"
                prefix="£"
                type="number"
                class="noStepNumber"
                label="Per Mile Fare"
                @input="resetError('per_mile_fare')"
              />
            </v-flex>
            <v-flex xs3 md3 px-2>
              <v-text-field
                :error-messages="errorForField('per_minute_fare')"
                :rules="modifierRules.per_minute_fare"
                v-model="modifierStore.per_minute_fare"
                prefix="£"
                type="number"
                class="noStepNumber"
                label="Per Minute Fare"
                @input="resetError('per_minute_fare')"
              />
            </v-flex>
            <v-flex xs3 md3 px-2>
              <v-text-field
                :error-messages="errorForField('additional_charge')"
                :rules="modifierRules.additional_charge"
                v-model="modifierStore.additional_charge"
                prefix="£"
                type="number"
                class="noStepNumber"
                label="Additional Charge"
                @input="resetError('additional_charge')"
              />
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="text-none" dark color="red darken-1" flat @click="cancel()">Cancel</v-btn>
        <v-btn class="text-none" dark color="blue darken-1" flat @click="save()">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import TimeInput from "@/components/widget/input/TimeInput.vue";

export default {
  name: "tariff_modifier_form",
  components: {
    TimeInput
  },
  props: {
    show: Boolean,
    modifierData: Object,
    errors: { type: Object, default: () => {} }
  },
  data: function() {
    return {
      showDialog: false,
      valid: false,
      modifierStore: null,
      modifierRules: {
        name: [
          v => !!v || "Name is required",
          v => v.length <= 200 || "Name must be less than 200 characters"
        ],
        hour_period_start: [
          v =>
            !v ||
            /^\d\d:\d\d$/.test(v) ||
            "Please enter time in the format HH:mm"
        ],
        hour_period_end: [
          v =>
            !v ||
            /^\d\d:\d\d$/.test(v) ||
            "Please enter time in the format HH:mm"
        ],
        day_period_start_time: [
          v =>
            !v ||
            /^\d\d:\d\d$/.test(v) ||
            "Please enter time in the format HH:mm"
        ],
        day_period_end_time: [
          v =>
            !v ||
            /^\d\d:\d\d$/.test(v) ||
            "Please enter time in the format HH:mm"
        ],
        base_fare: [
          v => !!v || "Base fare is required",
          v => /^\d+\.?\d?\d?$/.test(v) || "Please enter a valid amount"
        ],
        per_mile_fare: [
          v => !!v || "Per mile fare is required",
          v => /^\d+\.?\d?\d?$/.test(v) || "Please enter a valid amount"
        ],
        per_minute_fare: [
          v => !!v || v == 0 || "Per minute fare is required",
          v => /^\d+\.?\d?\d?$/.test(v) || "Please enter a valid amount"
        ],
        additional_charge: [
          v => !!v || v == 0 || "Additional charge is required",
          v => /^\d+\.?\d?\d?$/.test(v) || "Please enter a valid amount"
        ]
      },
      months: [
        { name: "", value: null },
        { name: "January", value: "1" },
        { name: "February", value: "2" },
        { name: "March", value: "3" },
        { name: "April", value: "4" },
        { name: "May", value: "5" },
        { name: "June", value: "6" },
        { name: "July", value: "7" },
        { name: "August", value: "8" },
        { name: "September", value: "9" },
        { name: "October", value: "10" },
        { name: "November", value: "11" },
        { name: "December", value: "12" }
      ],
      dates: [
        null,
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31"
      ]
    };
  },
  beforeMount: async function() {
    this.modifierStore = this.modifierData;
    this.showDialog = this.show;
  },
  methods: {
    errorForField: function(field) {
      try {
        return this.errors[field];
      } catch (err) {
        return null;
      }
    },
    resetError: function(field) {
      try {
        if (this.errors[field] != "") {
          this.errors[field] = "";
        }
      } catch (err) {}
    },
    validateForm: function() {
      this.$refs.modifierForm.validate();
    },
    cancel: function() {
      this.$emit("cancel");
    },
    save: function() {
      if (this.valid) {
        this.$emit("save", this.modifierStore);
      } else {
        this.$emit("snackbar", {
          message: "Please complete modifier form before saving",
          colour: "error"
        });
        this.validateForm();
      }
    }
  },
  watch: {
    valid: function() {
      this.$emit("validityChange", this.valid);
    },
    show: function() {
      this.showDialog = this.show;
    },
    showDialog: function() {
      if (!this.showDialog) {
        this.$emit("cancel");
        this.modifierStore = null;
      }
    }
  }
};
</script>

<style>
.noStepNumber input[type="number"] {
  -moz-appearance: textfield;
}
.noStepNumber input::-webkit-outer-spin-button,
.noStepNumber input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
</style>
